import React from "react";
import clsx from "clsx";
import Ink from "react-ink";
import "./style.css";

const Tab = ({ selected, onPress, children }) => {
  return (
    <div
      onClick={onPress}
      className={clsx(
        "tab_container",
        selected ? "tab_container-active" : "tab_container-inactive"
      )}
    >
      <p className="tab_para">{children}</p>
      <Ink />
    </div>
  );
};

export default Tab;
